"use strict";
var vec3 = require('gl-matrix/src/gl-matrix/vec3');
var AABB_1 = require('./AABB');
var zeros = vec3.create();
var RigidBody = (function () {
    function RigidBody(position, size, mass, friction, restitution, gravMult, options, onCollide, autoStep) {
        this.aabb = new AABB_1.default(position, size, options.onMove); // clone
        this.mass = mass;
        // max friction force - i.e. friction coefficient times gravity
        this.friction = friction;
        this.restitution = restitution;
        this.gravityMultiplier = gravMult;
        this.onCollide = onCollide;
        this.autoStep = autoStep;
        this.onStep = null;
        // internals
        this.velocity = vec3.create();
        this.resting = vec3.fromValues(0, 0, 0);
        this.inFluid = false;
        this._forces = vec3.create();
        this._impulses = vec3.create();
        this._oldResting = vec3.create();
        this._tmpBox = new AABB_1.default(zeros, zeros);
        this._dx = vec3.create();
        this._merged = [null, null, null];
        this._out = vec3.create();
    }
    RigidBody.prototype.applyForce = function (f) {
        vec3.add(this._forces, this._forces, f);
    };
    RigidBody.prototype.applyImpulse = function (i) {
        vec3.add(this._impulses, this._impulses, i);
    };
    // temp
    RigidBody.prototype.atRestX = function () {
        return this.resting[0];
    };
    RigidBody.prototype.atRestY = function () {
        return this.resting[1];
    };
    RigidBody.prototype.atRestZ = function () {
        return this.resting[2];
    };
    return RigidBody;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = RigidBody;
//# sourceMappingURL=RigidBody.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/physics/lib/RigidBody.js
 ** module id = 1176
 ** module chunks = 0
 **/